import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Layout, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import '../styles/Login.css';

const { Title } = Typography;
const { Content } = Layout;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const success = await login(values);
    setLoading(false);
    
    if (success) {
      navigate('/');
    }
  };

  return (
    <Layout className="login-layout">
      <Content className="login-content">
        <div className="login-logo">
          <h1 style={{ fontSize: '24px', color: '#8d6e63' }}>千方智能问诊系统</h1>
        </div>
        
        <Card className="login-card">
          <Title level={2} className="login-title">千方智能问诊系统</Title>
          
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            size="large"
          >
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: '请输入手机号码' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码' }
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="手机号码" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="密码" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-button" loading={loading}>
                登录
              </Button>
            </Form.Item>
            
            <Space className="login-links">
              <Link to="/register">注册新账号</Link>
              <Link to="/forgot-password">忘记密码</Link>
            </Space>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Login; 